
import { FaPhoneAlt } from "react-icons/fa";
import { TfiEmail } from "react-icons/tfi";
import { FaLocationDot } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";

export const NavTabs = [
    { nav: "Home", path: "home" },
    { nav: "About", path: "about" },
    { nav: "Services", path: "services" },
    { nav: "Contact", path: "contact" },
  ];
  

export const FooterIcons = [
    {
        icon: <FaFacebookF/>
    },
    {
        icon: <FaInstagram/>
    },
    {
        icon: <FaLinkedinIn/>
    },
];

export const Services = {
    title: "Our Services",
    links: [
        {
            link: 'Executive Experience'
        },
        {
            link: 'Policy and Process'
        },
        {
            link: 'Accounting'
        },
        {
            link: 'Strategic Consulting'
        },
        {
            link: 'Management Consulting'
        },
    ]
};

export const QuickLinks = {
    title: "QuickLinks",
    links: [
        {
            link: 'Home',
            path: "home",
        },
        {
            link: 'Services',
            path: "services"
        },
        {
            link: 'About us',
            path: "about"
        },
        {
            link: 'Contact us',
            path: "contact"
        },
    ]
};

export const BannerCardData = [
    {
        title: "Business Strategy",
        detail: "Align your goals with actionable strategies that drive growth."
    },
    {
        title: "Customized Solutions",
        detail: "Align your goals with actionable strategies that drive growth."
    },
    {
        title: "Technology Consulting",
        detail: "Embrace innovative technologies to enhance efficiency and scalability."
    },
];

export const Expertise = [
    {
        list: "C-Suite and public company board experience"
    },
    {
        list: "35 years banking and financial service experience"
    },
    {
        list: "Started a number of successful businesses"
    },
    {
        list: "Well connected in consumer finance space"
    },
    {
        list: "CPA for over 25 years"
    },
    {
        list: "MBA in Finance and BS in Accounting and Finance"
    },
];

export const AccordianData = [
    {
        title: "Can Consulting Services Help My Business Grow?",
        content: "Yes, consulting services can significantly contribute to business growth. Consultants can identify new opportunities, streamline operations, and implement strategies that drive profitability and scalability. They can also help businesses stay competitive in rapidly changing markets.",
    },
    {
        title: "What Are the Costs Associated with Consulting Services?",
        content: "",
    },
    {
        title: "Why Should I Hire a Consultant?",
        content: "",
    },
    {
        title: "What Industries Do Consulting Services Cover?",
        content: "",
    },
];

export const InfoData = [
    {
        icon: <FaPhoneAlt/>,
        title: "Any Questions?",
        content: "888-402-3444",
    },
    {
        icon: <TfiEmail/>,
        title: "Write Email?",
        content: "sales@arkconsultingservices.net"
    },
    {
        icon: <FaLocationDot/>,
        title: "Location",
        content: "12361 Hagen Ranch Road Suite 503 Boynton Beach, Florida 33437"
    },
];

export const SliderData = [
    {
        title: 'Executive Experience',
        content: "We help executives lead effectively through strategic guidance, leadership development, and tailored support to drive success."
    },
    {
        title: "Policy and Process Development",
        content: 'We help develop clear policies and efficient processes to improve compliance, consistency, and operational effectiveness.'
    },
    {
        title: "Strategic Consulting",
        content: "We provide strategic consulting to help businesses optimize operations and achieve sustainable growth."
    },
    {
        title: "Management Consulting",
        content: "Our management consulting services help businesses improve efficiency, streamline operations, and enhance organizational performance."
    },
];